import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-xxl-30" }
const _hoisted_3 = {
  class: "stepper stepper-1 d-flex flex-column flex-xl-row flex-row-fluid",
  id: "kt_stepper",
  ref: "stepperRef"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-400px\"><div class=\"stepper-nav d-flex flex-column pt-3 pb-15\"><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\"><div class=\"stepper-wrapper\"><div class=\"stepper-icon\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">1</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Sobre o seu negócio</h3><div class=\"stepper-desc\"> Queremos entender melhor como podemos ajudar a impulsionar o seu sucesso. </div></div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-wrapper\"><div class=\"stepper-icon\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">2</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Localização</h3><div class=\"stepper-desc\"> Informe o endereço do seu negócio para que possamos direcionar os serviços de forma adequada. </div></div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-wrapper\"><div class=\"stepper-icon\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">3</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Canais de Atendimento</h3><div class=\"stepper-desc\"> Indique os meios pelos quais clientes e parceiros podem entrar em contato com sua empresa. </div></div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-wrapper\"><div class=\"stepper-icon\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">4</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Redes Sociais</h3><div class=\"stepper-desc\"> Informe os perfis das suas redes sociais para que seus cliente e parceiros possam acompanhar suas atualizações e interagir com você. </div></div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-wrapper\"><div class=\"stepper-icon\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">5</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Confira seus dados</h3><div class=\"stepper-desc\"> Os detalhes de seu negócio são importantes para garantir a melhor experiência em nossa comunidade. </div></div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-wrapper\"><div class=\"stepper-icon\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">6</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Confirme sua conta</h3><div class=\"stepper-desc\"> Os detalhes de seu negócio são importantes para garantir a melhor experiência em nossa comunidade. </div></div></div></div></div></div>", 1)
const _hoisted_5 = { class: "d-flex flex-row-fluid justify-content-center" }
const _hoisted_6 = {
  id: "about_business",
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "w-100" }
const _hoisted_8 = { class: "pb-10 pb-lg-15" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-dark display-6" }, " Sobre o seu negócio ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-desc" }, " Conte-nos um pouco sobre sua empresa, seus produtos/serviços e objetivos. Queremos entender melhor como podemos ajudar a impulsionar o seu sucesso. ", -1)
const _hoisted_11 = {
  key: 0,
  class: "text-muted fw-bold fs-3"
}
const _hoisted_12 = { class: "fv-row mb-5" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Qual o nome da sua empresa?", -1)
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "fv-row mb-5" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Em que segmento sua empresa atua?", -1)
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "fv-row mb-5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Poderia descrever o seu negócio em poucas palavras?", -1)
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = {
  id: "business_location",
  class: "",
  "data-kt-stepper-element": "content"
}
const _hoisted_26 = { class: "w-100" }
const _hoisted_27 = { class: "pb-10 pb-lg-15" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-dark display-6" }, " Detalhes de sua Localização ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-desc" }, " Informe o endereço completo do seu negócio para que possamos direcionar os serviços de forma adequada. ", -1)
const _hoisted_30 = {
  key: 0,
  class: "text-muted fw-bold fs-3"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "text-primary fw-bolder"
}, "Adicionar Endereço", -1)
const _hoisted_32 = { class: "fv-row mb-5" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Seu negócio possui atendimento presencial?", -1)
const _hoisted_34 = { class: "fv-row mb-5" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "CEP", -1)
const _hoisted_36 = { class: "fv-row mb-5" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Endereço", -1)
const _hoisted_38 = { class: "fv-row mb-5" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Número", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "fv-row row mb-5" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, [
    /*#__PURE__*/_createTextVNode(" Porto Alegre"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Rio Grande do Sul"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Brasil ")
  ])
], -1)
const _hoisted_41 = {
  id: "business_channels",
  class: "",
  "data-kt-stepper-element": "content"
}
const _hoisted_42 = { class: "w-100" }
const _hoisted_43 = { class: "pb-10 Indique os meios pelos quais podemos entrar em contato com você, como telefone, e-mail ou redes sociais, para uma comunicação eficiente e ágil.pb-lg-15" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-dark display-6" }, " Canais de Atendimento ", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-desc" }, " Indique os meios pelos quais clientes e parceiros podem entrar em contato com sua empresa, como telefone, e-mail ou redes sociais, para uma comunicação eficiente e ágil. ", -1)
const _hoisted_46 = {
  key: 0,
  class: "text-muted fw-bold fs-3"
}
const _hoisted_47 = { class: "row" }
const _hoisted_48 = {
  key: 0,
  class: "col-xl-6"
}
const _hoisted_49 = { class: "mb-5" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Nome", -1)
const _hoisted_51 = { class: "col-xl-12" }
const _hoisted_52 = { class: "mb-5" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Email", -1)
const _hoisted_54 = { class: "fv-plugins-message-container" }
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-xl-12" }
const _hoisted_58 = { class: "mb-5" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, " Telefone ", -1)
const _hoisted_60 = { class: "fv-plugins-message-container" }
const _hoisted_61 = { class: "fv-help-block" }
const _hoisted_62 = { class: "col-xl-12" }
const _hoisted_63 = { class: "mb-5" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, " Site ", -1)
const _hoisted_65 = { class: "fv-plugins-message-container" }
const _hoisted_66 = { class: "fv-help-block" }
const _hoisted_67 = { class: "col-xl-12" }
const _hoisted_68 = { class: "mb-5" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, " WhatsApp ", -1)
const _hoisted_70 = { class: "fv-plugins-message-container" }
const _hoisted_71 = { class: "fv-help-block" }
const _hoisted_72 = {
  id: "business_socials",
  class: "",
  "data-kt-stepper-element": "content"
}
const _hoisted_73 = { class: "w-100" }
const _hoisted_74 = { class: "pb-10 pb-lg-15" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-dark display-6" }, "Redes Sociais", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-desc" }, " Informe os perfis das suas redes sociais para que seus cliente e parceiros possam acompanhar suas atualizações e interagir com você de maneira mais dinâmica e conectada. ", -1)
const _hoisted_77 = {
  key: 0,
  class: "text-muted fw-bold fs-3"
}
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "col-xl-6" }
const _hoisted_80 = { class: "mb-5" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Instagram", -1)
const _hoisted_82 = { class: "col-xl-6" }
const _hoisted_83 = { class: "mb-5" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Facebook", -1)
const _hoisted_85 = { class: "row" }
const _hoisted_86 = { class: "col-xl-6" }
const _hoisted_87 = { class: "mb-5" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Youtube", -1)
const _hoisted_89 = { class: "col-xl-6" }
const _hoisted_90 = { class: "mb-5" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Tiktok", -1)
const _hoisted_92 = { class: "row" }
const _hoisted_93 = { class: "col-xl-6" }
const _hoisted_94 = { class: "mb-5" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Twitter", -1)
const _hoisted_96 = {
  key: 0,
  id: "business_payment",
  class: "",
  "data-kt-stepper-element": "content"
}
const _hoisted_97 = { class: "w-100" }
const _hoisted_98 = { class: "pb-10 pb-lg-15" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-dark display-6" }, "Pagamentos", -1)
const _hoisted_100 = {
  key: 0,
  class: "text-muted fw-bold fs-3"
}
const _hoisted_101 = { class: "row" }
const _hoisted_102 = { class: "col-xl-6" }
const _hoisted_103 = { class: "mb-5" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark form-label" }, "Name on Card", -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("span", { class: "form-text text-muted" }, "Please enter your Card Name.", -1)
const _hoisted_106 = { class: "col-xl-6" }
const _hoisted_107 = { class: "mb-5" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark form-label" }, "Card Number", -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("span", { class: "form-text text-muted" }, "Please enter your Address.", -1)
const _hoisted_110 = { class: "row" }
const _hoisted_111 = { class: "col-xl-4" }
const _hoisted_112 = { class: "mb-5" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark form-label" }, "Card Expiry Month", -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("span", { class: "form-text text-muted" }, "Please enter your Card Expiry Month.", -1)
const _hoisted_115 = { class: "col-xl-4" }
const _hoisted_116 = { class: "mb-5" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark form-label" }, "Card Expiry Year", -1)
const _hoisted_118 = /*#__PURE__*/_createElementVNode("span", { class: "form-text text-muted" }, "Please enter your Card Expiry Year.", -1)
const _hoisted_119 = { class: "col-xl-4" }
const _hoisted_120 = { class: "mb-5" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark form-label" }, "Card CVV Number", -1)
const _hoisted_122 = /*#__PURE__*/_createElementVNode("span", { class: "form-text text-muted" }, "Please enter your Card CVV Number.", -1)
const _hoisted_123 = {
  id: "business_confirm_account",
  "data-kt-stepper-element": "content"
}
const _hoisted_124 = { class: "w-100" }
const _hoisted_125 = { class: "pb-10 pb-lg-15" }
const _hoisted_126 = { class: "fw-bolder text-dark display-6" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-desc" }, " Por favor, verifique e confirme seus dados para concluir o processo de inscrição e desfrutar de todos os benefícios de ser um membro. Seus detalhes são importantes para garantir a melhor experiência em nossa comunidade. ", -1)
const _hoisted_128 = {
  key: 0,
  class: "fv-row mb-5"
}
const _hoisted_129 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Como você se chama?", -1)
const _hoisted_130 = { class: "fv-plugins-message-container" }
const _hoisted_131 = { class: "fv-help-block" }
const _hoisted_132 = {
  key: 1,
  class: "fv-row mb-5"
}
const _hoisted_133 = { class: "fw-bolder text-muted display-6" }
const _hoisted_134 = { class: "fv-row mb-5" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Qual sua relação com essa empresa?", -1)
const _hoisted_136 = ["value"]
const _hoisted_137 = { class: "fv-plugins-message-container" }
const _hoisted_138 = { class: "fv-help-block" }
const _hoisted_139 = {
  key: 2,
  class: "fv-row mb-5"
}
const _hoisted_140 = { class: "mb-5" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, " Telefone ", -1)
const _hoisted_142 = { class: "fv-plugins-message-container" }
const _hoisted_143 = { class: "fv-help-block" }
const _hoisted_144 = {
  key: 3,
  class: "fv-row mb-5"
}
const _hoisted_145 = { class: "mb-5" }
const _hoisted_146 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Senha", -1)
const _hoisted_147 = { class: "fv-plugins-message-container" }
const _hoisted_148 = { class: "fv-help-block" }
const _hoisted_149 = {
  id: "business_confirm_account",
  class: "",
  "data-kt-stepper-element": "content"
}
const _hoisted_150 = { class: "w-100" }
const _hoisted_151 = { class: "pb-10 pb-lg-15" }
const _hoisted_152 = { class: "fw-bolder text-dark display-6" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-desc" }, " Para ajudar a proteger sua conta, enviamos ao seu telefone um código de confirmação. Por favor, conclua a verificação: ", -1)
const _hoisted_154 = { class: "fv-row mb-5" }
const _hoisted_155 = { class: "mb-5" }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, " Código de Verificação ", -1)
const _hoisted_157 = { class: "fv-plugins-message-container" }
const _hoisted_158 = { class: "fv-help-block" }
const _hoisted_159 = { class: "fv-row mb-5" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-view el-icon--right" }, null, -1)
const _hoisted_161 = { class: "d-flex justify-content-between pt-10" }
const _hoisted_162 = { class: "mr-2" }
const _hoisted_163 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_164 = {
  type: "submit",
  class: "btn btn-lg btn-primary fw-bolder py-4 ps-8 me-3",
  "data-kt-stepper-action": "submit"
}
const _hoisted_165 = { class: "svg-icon svg-icon-4 ms-2" }
const _hoisted_166 = { class: "svg-icon svg-icon-4 ms-1" }
const _hoisted_167 = {
  key: 1,
  class: "row mt-15 pt-8 mb-5"
}
const _hoisted_168 = {
  key: 0,
  class: "fw-bolder mb-3 mt-6"
}
const _hoisted_169 = {
  key: 1,
  class: "text-gray-600 fw-bold lh-lg my-3"
}
const _hoisted_170 = { class: "text-gray-600 fw-bold lh-lg mb-8" }
const _hoisted_171 = { key: 0 }
const _hoisted_172 = { key: 1 }
const _hoisted_173 = {
  key: 2,
  class: "fw-bolder mb-3"
}
const _hoisted_174 = { class: "text-gray-600 fw-bold lh-lg mb-8" }
const _hoisted_175 = { key: 0 }
const _hoisted_176 = { key: 1 }
const _hoisted_177 = { key: 2 }
const _hoisted_178 = { key: 3 }
const _hoisted_179 = {
  key: 3,
  class: "fw-bolder mb-3"
}
const _hoisted_180 = { class: "text-gray-600 fw-bold lh-lg mb-8" }
const _hoisted_181 = { key: 0 }
const _hoisted_182 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-40px symbol-2by3 me-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/duotune/social/soc005.svg",
    alt: "",
    class: "mh-25px"
  })
], -1)
const _hoisted_183 = { key: 1 }
const _hoisted_184 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-40px symbol-2by3 me-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/duotune/social/soc004.svg",
    alt: "",
    class: "mh-25px"
  })
], -1)
const _hoisted_185 = { key: 2 }
const _hoisted_186 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-40px symbol-2by3 me-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/duotune/social/soc006.svg",
    alt: "",
    class: "mh-25px"
  })
], -1)
const _hoisted_187 = { key: 3 }
const _hoisted_188 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-40px symbol-2by3 me-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/duotune/social/soc007.svg",
    alt: "",
    class: "mh-25px"
  })
], -1)
const _hoisted_189 = { key: 4 }
const _hoisted_190 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-40px symbol-2by3 me-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/duotune/social/soc008.svg",
    alt: "",
    class: "mh-25px"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_page = _resolveComponent("header-page")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_header_page, {
      title: _ctx.title,
      subtitle: _ctx.subtitle,
      search: _ctx.search,
      bgImage: "https://i.pinimg.com/originals/87/f1/c0/87f1c0640ab0bb89383af44c67d9786a.jpg",
      bgImageSmall: "https://i.pinimg.com/originals/87/f1/c0/87f1c0640ab0bb89383af44c67d9786a.jpg",
      lg: false,
      bgHex: "#fff",
      margin: "mb-8"
    }, null, 8, ["title", "subtitle", "search"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", {
              class: "w-100 w-md-400px w-xl-500px",
              novalidate: "novalidate",
              id: "kt_stepper_form",
              onSubmit: _cache[30] || (_cache[30] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.formSubmit && _ctx.formSubmit(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    false
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createTextVNode(" Possui dúvidas? "),
                          _createVNode(_component_router_link, {
                            to: "/faq",
                            class: "text-primary fw-bolder"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Receba ajuda")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-lg form-control-solid",
                      name: "companyName",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyName) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.companyName]
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.companyNameError), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-lg form-select-solid",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sector) = $event)),
                      name: "sector"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectors, (sector) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: sector.id,
                          value: sector.id,
                          selected: ""
                        }, _toDisplayString(sector.label), 9, _hoisted_18))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.sector]
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.sectorError), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      class: "form-control form-control-lg form-control-solid py-5",
                      name: "confirmSignupPhone",
                      placeholder: "",
                      modelValue: _ctx.bio,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bio) = $event)),
                      maxlength: "400",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.bioError), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _hoisted_29,
                    false
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createTextVNode(" Está em um endereço diferente ? "),
                          _hoisted_31
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode(_component_el_switch, {
                      style: {"display":"block"},
                      modelValue: _ctx.data.onlyOnlineBussiness,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.onlyOnlineBussiness) = $event)),
                      "active-color": "#13ce66",
                      "inactive-color": "#ff4949",
                      "active-text": "Sim",
                      "inactive-text": "Não"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-lg form-control-solid",
                      name: "cep",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.data.cep) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.data.cep]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-lg form-control-solid",
                      name: "address1",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.data.addressLine) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.data.addressLine]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-lg form-control-solid",
                      name: "address1",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.data.addressNumber) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.data.addressNumber]
                    ])
                  ]),
                  _hoisted_40
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _hoisted_45,
                    false
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createTextVNode(" Can't find your channel? "),
                          _createVNode(_component_router_link, {
                            to: "/faq",
                            class: "text-primary fw-bolder"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Get Help")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    false
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _hoisted_50,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-lg form-control-solid",
                              name: "channelname",
                              placeholder: "",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.data.name) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.data.name]
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          class: "form-control form-control-lg form-control-solid",
                          name: "email",
                          placeholder: "",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.email) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.email]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.emailError), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _hoisted_59,
                        _createVNode(_component_el_input, {
                          name: "channelphone",
                          placeholder: "",
                          modelValue: _ctx.phone,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.phone) = $event))
                        }, {
                          prepend: _withCtx(() => [
                            _createTextVNode("+55")
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.phoneError), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _hoisted_64,
                        _createVNode(_component_el_input, {
                          name: "website",
                          placeholder: "",
                          modelValue: _ctx.website,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.website) = $event))
                        }, {
                          prepend: _withCtx(() => [
                            _createTextVNode("https://")
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.websiteError), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _hoisted_69,
                        _createVNode(_component_el_input, {
                          name: "whatsapp",
                          placeholder: "",
                          modelValue: _ctx.whatsapp,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.whatsapp) = $event))
                        }, {
                          prepend: _withCtx(() => [
                            _createTextVNode("+55")
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.whatsappError), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _hoisted_75,
                    _hoisted_76,
                    false
                      ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                          _createTextVNode(" Can't find your channel? "),
                          _createVNode(_component_router_link, {
                            to: "/faq",
                            class: "text-primary fw-bolder"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Get Help")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _hoisted_81,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control form-control-lg form-control-solid",
                          name: "instagram",
                          placeholder: "",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.data.instagram) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.data.instagram]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("div", _hoisted_83, [
                        _hoisted_84,
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          class: "form-control form-control-lg form-control-solid",
                          name: "facebook",
                          placeholder: "",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.data.facebook) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.data.facebook]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("div", _hoisted_87, [
                        _hoisted_88,
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control form-control-lg form-control-solid",
                          name: "youtube",
                          placeholder: "",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.data.youtube) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.data.youtube]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("div", _hoisted_90, [
                        _hoisted_91,
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control form-control-lg form-control-solid",
                          name: "tiktok",
                          placeholder: "",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.data.tiktok) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.data.tiktok]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("div", _hoisted_93, [
                      _createElementVNode("div", _hoisted_94, [
                        _hoisted_95,
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control form-control-lg form-control-solid",
                          name: "twitter",
                          placeholder: "",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.data.twitter) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.data.twitter]
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                    _createElementVNode("div", _hoisted_97, [
                      _createElementVNode("div", _hoisted_98, [
                        _hoisted_99,
                        true
                          ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                              _createTextVNode(" Having Issues? "),
                              _createVNode(_component_router_link, {
                                to: "/faq",
                                class: "text-primary fw-bolder"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Get Help")
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_101, [
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("div", _hoisted_103, [
                            _hoisted_104,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-lg form-control-solid",
                              name: "ccname",
                              placeholder: "Card Name",
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.data.nameOnCard) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.data.nameOnCard]
                            ]),
                            _hoisted_105
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_106, [
                          _createElementVNode("div", _hoisted_107, [
                            _hoisted_108,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-lg form-control-solid",
                              name: "ccnumber",
                              placeholder: "Card Number",
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.data.cardNumber) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.data.cardNumber]
                            ]),
                            _hoisted_109
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_110, [
                        _createElementVNode("div", _hoisted_111, [
                          _createElementVNode("div", _hoisted_112, [
                            _hoisted_113,
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control form-control-lg form-control-solid",
                              name: "ccmonth",
                              placeholder: "Card Expiry Month",
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.data.cardExpiryMonth) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.data.cardExpiryMonth]
                            ]),
                            _hoisted_114
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_115, [
                          _createElementVNode("div", _hoisted_116, [
                            _hoisted_117,
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control form-control-lg form-control-solid",
                              name: "ccyear",
                              placeholder: "Card Expire Year",
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.data.cardExpiryYear) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.data.cardExpiryYear]
                            ]),
                            _hoisted_118
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_119, [
                          _createElementVNode("div", _hoisted_120, [
                            _hoisted_121,
                            _withDirectives(_createElementVNode("input", {
                              type: "password",
                              class: "form-control form-control-lg form-control-solid",
                              name: "cccvv",
                              placeholder: "Card CVV Number",
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.data.cardCVVNumber) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.data.cardCVVNumber]
                            ]),
                            _hoisted_122
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_123, [
                _createElementVNode("div", _hoisted_124, [
                  _createElementVNode("div", _hoisted_125, [
                    _createElementVNode("h3", _hoisted_126, _toDisplayString(_ctx.companyName), 1),
                    _hoisted_127
                  ]),
                  (
                    !_ctx.currentAuthenticatedUser &&
                    !_ctx.currentAuthenticatedUser.username
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                        _hoisted_129,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.yourName) = $event)),
                          type: "text",
                          class: "form-control form-control-lg form-control-solid",
                          name: "yourName",
                          placeholder: ""
                        }, null, 512), [
                          [_vModelText, _ctx.yourName]
                        ]),
                        _createElementVNode("div", _hoisted_130, [
                          _createElementVNode("div", _hoisted_131, _toDisplayString(_ctx.yourNameError), 1)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_132, [
                        _createElementVNode("h4", _hoisted_133, _toDisplayString(_ctx.currentProfile.name), 1)
                      ])),
                  _createElementVNode("div", _hoisted_134, [
                    _hoisted_135,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-lg form-select-solid",
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.leadRelationship) = $event)),
                      name: "leadRelationship"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leadRelationshipList, (sector) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: sector.id,
                          value: sector.id,
                          selected: ""
                        }, _toDisplayString(sector.label), 9, _hoisted_136))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.leadRelationship]
                    ]),
                    _createElementVNode("div", _hoisted_137, [
                      _createElementVNode("div", _hoisted_138, _toDisplayString(_ctx.leadRelationshipError), 1)
                    ])
                  ]),
                  (
                    !_ctx.currentAuthenticatedUser &&
                    !_ctx.currentAuthenticatedUser.username
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                        _createElementVNode("div", _hoisted_140, [
                          _hoisted_141,
                          _createVNode(_component_el_input, {
                            name: "signupPhone",
                            placeholder: "",
                            modelValue: _ctx.signupPhone,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.signupPhone) = $event))
                          }, {
                            prepend: _withCtx(() => [
                              _createTextVNode("+55")
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_142, [
                          _createElementVNode("div", _hoisted_143, _toDisplayString(_ctx.signupPhoneError), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                    !_ctx.currentAuthenticatedUser &&
                    !_ctx.currentAuthenticatedUser.username
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                        _createElementVNode("div", _hoisted_145, [
                          _hoisted_146,
                          _createVNode(_component_el_input, {
                            style: {"width":"100%"},
                            class: "form-control form-control-lg form-control-solid",
                            name: "password",
                            placeholder: "",
                            modelValue: _ctx.password,
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.password) = $event)),
                            "show-password": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_147, [
                          _createElementVNode("div", _hoisted_148, _toDisplayString(_ctx.passwordError), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_149, [
                _createElementVNode("div", _hoisted_150, [
                  _createElementVNode("div", _hoisted_151, [
                    _createElementVNode("h3", _hoisted_152, _toDisplayString(_ctx.yourName), 1),
                    _hoisted_153
                  ]),
                  _createElementVNode("div", _hoisted_154, [
                    _createElementVNode("div", _hoisted_155, [
                      _hoisted_156,
                      _createVNode(_component_el_input, {
                        type: "text",
                        class: "form-control form-control-lg form-control-solid",
                        name: "confirmSignupPhone",
                        placeholder: "",
                        modelValue: _ctx.confirmSignupPhone,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.confirmSignupPhone) = $event)),
                        minLength: "6",
                        maxlength: "6",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_157, [
                      _createElementVNode("div", _hoisted_158, _toDisplayString(_ctx.confirmSignupPhoneError), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_159, [
                    _createVNode(_component_el_link, {
                      onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.resendConfirmationCode(_ctx.signupPhone)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Reenviar o código de confirmação "),
                        _hoisted_160
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_161, [
                _createElementVNode("div", _hoisted_162, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-light-primary fw-bolder py-4 pe-8 me-3",
                    "data-kt-stepper-action": "previous",
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.prevStep()))
                  }, [
                    _createElementVNode("span", _hoisted_163, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr063.svg" })
                    ]),
                    _createTextVNode(" Anterior ")
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", _hoisted_164, [
                    _createTextVNode(" Confirmar "),
                    _createElementVNode("span", _hoisted_165, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr012.svg" })
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-primary fw-bolder py-4 ps-8 me-3",
                    "data-kt-stepper-action": "next",
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.nextStep()))
                  }, [
                    _createTextVNode(" Continuar "),
                    _createElementVNode("span", _hoisted_166, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ])
                  ])
                ])
              ]),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                    (_ctx.data.companyName)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_168, _toDisplayString(_ctx.data.companyName), 1))
                      : _createCommentVNode("", true),
                    (_ctx.data.bio)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_169, _toDisplayString(_ctx.data.bio), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_170, [
                      (_ctx.data.addressLine)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_171, _toDisplayString(_ctx.data.addressLine) + ", " + _toDisplayString(_ctx.data.addressNumber), 1))
                        : _createCommentVNode("", true),
                      (_ctx.data.cep)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_172, _toDisplayString(_ctx.data.cep), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.data.email || _ctx.data.phone || _ctx.data.website || _ctx.data.whatsapp)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_173, " Canais de Atendimento "))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_174, [
                      (_ctx.data.email)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_175, "Email: " + _toDisplayString(_ctx.data.email), 1))
                        : _createCommentVNode("", true),
                      (_ctx.data.phone)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_176, "Telefone: " + _toDisplayString(_ctx.data.phone), 1))
                        : _createCommentVNode("", true),
                      (_ctx.data.website)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_177, "Site: " + _toDisplayString(_ctx.data.website), 1))
                        : _createCommentVNode("", true),
                      (_ctx.data.whatsapp)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_178, "WhatsApp: " + _toDisplayString(_ctx.data.whatsapp), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (
                  _ctx.data.instagram ||
                  _ctx.data.facebook ||
                  _ctx.data.twitter ||
                  _ctx.data.youtube ||
                  _ctx.data.tiktok
                )
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_179, " Redes Sociais "))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_180, [
                      (_ctx.data.instagram)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_181, [
                            _hoisted_182,
                            _createTextVNode(" @" + _toDisplayString(_ctx.data.instagram), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.data.facebook)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_183, [
                            _hoisted_184,
                            _createTextVNode(" @" + _toDisplayString(_ctx.data.facebook), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.data.twitter)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                            _hoisted_186,
                            _createTextVNode(" @" + _toDisplayString(_ctx.data.twitter), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.data.youtube)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                            _hoisted_188,
                            _createTextVNode(" @" + _toDisplayString(_ctx.data.youtube), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.data.tiktok)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_189, [
                            _hoisted_190,
                            _createTextVNode(" @" + _toDisplayString(_ctx.data.tiktok), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 32)
          ])
        ], 512)
      ])
    ])
  ], 64))
}